// Cliente da painel-farmacia-api (ADR-025 Fase 2). Ações privilegiadas de
// domínio próprio — o painel manda o Firebase ID token; a API verifica.
import { auth } from "./firebase";
import type { CustomDomainStatus } from "@farmacias/schema";

const BASE = (import.meta.env.VITE_PAINEL_API_URL ?? "").replace(/\/$/, "");

export interface DomainHost {
  host: string;
  role: "primary" | "secondary";
  status: CustomDomainStatus;
  detail: string | null;
  aRecord: string;
}

export interface DomainInfo {
  domain: string | null;
  status: CustomDomainStatus;
  lbIp: string;
  hosts: DomainHost[];
}

export const painelApiConfigured = BASE.length > 0;

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  if (!painelApiConfigured) throw new Error("VITE_PAINEL_API_URL não configurada.");
  const user = auth.currentUser;
  if (!user) throw new Error("Sessão expirada — entre de novo.");
  const token = await user.getIdToken();
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: { ...init?.headers, authorization: `Bearer ${token}`, "content-type": "application/json" },
  });
  const text = await res.text();
  const body = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(body.error ?? `HTTP ${res.status}`);
  return body as T;
}

export const getDomain = (slug: string) =>
  call<DomainInfo>(`/v1/farmacias/${encodeURIComponent(slug)}/domain`);

export const setDomain = (slug: string, domain: string) =>
  call<DomainInfo>(`/v1/farmacias/${encodeURIComponent(slug)}/domain`, {
    method: "PUT",
    body: JSON.stringify({ domain }),
  });

export const removeDomain = (slug: string) =>
  call<DomainInfo>(`/v1/farmacias/${encodeURIComponent(slug)}/domain`, { method: "DELETE" });
